// extracted by mini-css-extract-plugin
module.exports = {"MainSection":"Layout_MainSection__1JSIu"};